/* Audited tag filtering: explicit navigation, URL encoding and delegated events. */
(() => {
  'use strict';
  const pendingKey='dluxca_collection_filter_pending_v1';
  function trackingAllowed(){try{return window.DluxcaUsageEnabled===true&&!window.Shopify?.designMode&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;}catch{return false;}}
  function pageKey(raw){const u=new URL(raw,location.origin);if(u.origin!==location.origin)return null;u.hash='';u.searchParams.sort();return u.pathname+u.search;}
  function discardPending(){try{sessionStorage.removeItem(pendingKey);}catch(_){}}
  function rememberFilter(url,applying){
    try{
      discardPending();
      if(!applying||!trackingAllowed())return;
      const target=pageKey(url),source=pageKey(location.href);
      if(!target||target===source||!new URL(url,location.origin).pathname.includes('/collections/'))return;
      sessionStorage.setItem(pendingKey,JSON.stringify({target,source,at:Date.now()}));
    }catch(_){}
  }
  function confirmFilter(){
    try{
      const raw=sessionStorage.getItem(pendingKey);if(!raw)return;
      const pending=JSON.parse(raw),age=Date.now()-pending.at;
      const navigation=performance.getEntriesByType?.('navigation')?.[0];
      if(Number.isFinite(age)&&age>=0&&age<=120000&&pending.source===pageKey(location.href))return;
      if(!Number.isFinite(age)||age<0||age>120000||pending.target!==pageKey(location.href)||
         (navigation&&navigation.type!=='navigate')||
         (document.referrer&&pageKey(document.referrer)!==pending.source)){
        discardPending();return;
      }
      if(!document.body?.classList.contains('template-collection')||
         !document.querySelector('[data-section-type="collection"] .product-list--collection, [data-section-type="collection"] .empty-state')){discardPending();return;}
      if(!trackingAllowed()||typeof window.DluxcaUsage?.track!=='function')return;
      discardPending();
      window.DluxcaUsage.track('collection_filter_applied','success');
    }catch(_){discardPending();}
  }
  // The consent API can finish loading after the deferred theme scripts.
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',confirmFilter,{once:true});else confirmFilter();
  document.addEventListener('visitorConsentCollected',confirmFilter);
  window.addEventListener('pageshow',e=>{if(e.persisted){discardPending();return;}confirmFilter();});
  let confirmChecks=0;const confirmTimer=setInterval(()=>{confirmFilter();if(++confirmChecks>=30)clearInterval(confirmTimer);},1000);

  const openActive=()=>document.querySelectorAll('.filter-active').forEach(item=>{
    const group=item.closest('.collection__filter-group');if(!group)return;
    group.querySelector('[data-action="toggle-collapsible"]')?.setAttribute('aria-expanded','true');
    const panel=group.querySelector('.collection__filter-collapsible');
    if(panel){panel.setAttribute('aria-hidden','false');panel.style.visibility='visible';panel.style.height='auto';}
  });
  openActive();document.addEventListener('shopify:section:load',openActive);
  window.addEventListener('click',event=>{
    const link=event.target.closest?.('.collection-filter-link[data-tag],a[data-single-product-type][data-product-type-value],a.collection-product-type-link');
    if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;
    if(link.matches('[data-single-product-type]')){
      if(!/\/collections\/new-arrival(?:\/|$)/.test(location.pathname)){
        rememberFilter(link.href,!link.closest('li')?.classList.contains('filter-active')&&!!link.closest('.collection__filter-group'));
        return;
      }
      event.preventDefault();event.stopImmediatePropagation();
      const url=new URL(location.href);url.searchParams.delete('page');url.searchParams.delete('section_id');url.searchParams.delete('filter.p.product_type');
      if(!link.closest('li')?.classList.contains('filter-active'))url.searchParams.set('filter.p.product_type',link.dataset.productTypeValue);
      rememberFilter(url,!link.closest('li')?.classList.contains('filter-active'));
      location.assign(url);return;
    }
    if(link.matches('a.collection-product-type-link')){
      rememberFilter(link.href,!link.closest('li')?.classList.contains('filter-active')&&!!link.closest('.collection__filter-group'));
      return;
    }
    if(!link.dataset.colurl)return;
    event.preventDefault();event.stopImmediatePropagation();
    const remove=!!link.closest('.collection__active-filters');
    const item=link.closest('li');const active=item?.classList.contains('filter-active');
    const tags=new Set();
    const group=item?.parentElement;
    document.querySelectorAll('.collection__filter-group-list .filter-active .collection-filter-link[data-tag]').forEach(a=>{
      if(a.dataset.tag===link.dataset.tag)return;
      if(!remove && a.closest('li')?.parentElement===group)return;
      if(a.dataset.tag)tags.add(a.dataset.tag);
    });
    if(!remove&&!active)tags.add(link.dataset.tag);
    const url=new URL(link.dataset.colurl,location.origin);if(url.origin!==location.origin)return;
    url.pathname=url.pathname.replace(/\/$/,'')+(tags.size?'/'+[...tags].map(encodeURIComponent).join('+'):'');
    url.search=location.search;url.searchParams.delete('page');url.searchParams.delete('section_id');url.searchParams.delete('audit_page');
    rememberFilter(url,!remove&&!active);
    location.assign(url);
  },true);
})();
